import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {PortalService} from '../../model/PortalService';
import {ResponseConfigDelayService} from '../../services/response-config-delay.service';
import {ModalService} from 'ngx-dynamic-modal';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {ResponseConfigDelayModalComponent} from '../../modals/response-config-delay-modal/response-config-delay-modal.component';

@Component({
  selector: 'app-response-config-delay',
  templateUrl: './response-config-delay.component.html',
  styleUrls: ['./response-config-delay.component.scss']
})
export class ResponseConfigDelayComponent implements OnInit, OnChanges {

  @Input() portalService: PortalService;
  rows:any=[];
  enabled:boolean;
  constructor(private respDelayService: ResponseConfigDelayService,
              private modal:ModalService,
              private alerta:AlertaService) { }

  ngOnInit() {}

  ngOnChanges(){
      this.getResponseConfigDelay();
  }

  openModal(element= null)
  {
        let params={portal_pk:this.portalService.getPkPortal(),service_pk:this.portalService.getPkService(), camp_pk: this.portalService.pkCamp};
        this.modal.addDynamicComponent(ResponseConfigDelayModalComponent, {element,params}, (res) => {
           this.getResponseConfigDelay();
        })

  }

  deleteRespConf(element) {
        this.alerta.addAlert('confirm','Do you want to Delete this Resp Delay config?')
            .then((result)=>{
                if(result.value){
                    this.enabled=true;
                    this.respDelayService.removeRespConfigDelay(element.pk)
                        .subscribe( result => {
                        }, error => {
                            console.log(error);
                            this.enabled=false;
                        }, () => {
                            this.alerta.addAlert('success','Response Delay config Deleted Succesfully!!');
                            let indx=this.rows.indexOf(element);
                            this.rows.splice(indx,1);
                            this.enabled=false
                        })
                }
            })
  }
  getResponseConfigDelay(){
      this.enabled=true;
      this
          .respDelayService
          .getRespConfigDelay({ portal_pk: this.portalService.getPkPortal(), service_pk: this.portalService.getPkService(), camp_pk : this.portalService.pkCamp})
          .subscribe(result => {
              this.rows=result;
              this.enabled=false;
          } )
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/response-config-delay/response-config-delay.component.ts